import React from 'react';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { ITableInputWidgetProps } from './TableInputWidgetComponent';
import { TableInputContainer } from './render/TableInputContainer';

export function TableInputWidgetPreview(props: ITableInputWidgetProps) {
  const options = getWidgetProps(props);

  return (
    <TableInputContainer {...props} options={options}>
      {props.children}
    </TableInputContainer>
  );
}
